import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { api } from '@/api';
import { END_POINT } from '@/constants/end-point.constants';
import { SALE_AREA_QUERY_KEYS } from '@/constants/query-keys.constants';
import { useUserInformation } from '@/hooks/use-user-information';
import { SaleAreasResponse } from '@/types/common.types';

const MINUTE = 60 * 1000;

const fetchSaleAreas = (): Promise<AxiosResponse<SaleAreasResponse>> =>
  api.get(END_POINT.saleAreas);

export const useFetchSaleAreas = () => {
  const { isChainRole } = useUserInformation();

  return useQuery({
    queryFn: fetchSaleAreas,
    queryKey: SALE_AREA_QUERY_KEYS.lists(),
    select: data => data.data.sale_areas,
    enabled: !isChainRole,
    staleTime: 5 * MINUTE,
  });
};

export const useSaleAreas = () => {
  const queryClient = useQueryClient();
  const queryKey = SALE_AREA_QUERY_KEYS.lists();
  const axiosResponse =
    queryClient.getQueryData<AxiosResponse<Partial<SaleAreasResponse>>>(
      queryKey,
    );

  return axiosResponse?.data ?? {};
};
